<template>
 
  <!--新闻动态-->
  <div class="content_list_layout">
    <div class="file_div" v-for="(item,index) in showList" :key="index" @click="toOpenFile(item.msgUrl)">
      <i class="iconfont icon-website-PDF"></i>
      <div>{{item.title}}</div>
    </div>
    <div class="web_fenye" v-if="showList && showList.length > 0">
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :page-range="3"
        :clickHandler="pageClick"
        :first-last-button="false"
        first-button-text="<<"
        last-button-text=">>"
        :prevText="'<'"
        :nextText="'>'"
      >
      </paginate>
    </div>
   
  </div>
       
</template>

<script>

export default {
  name: 'FileTitleListView',
  components:{},
  props: {
    titleName:{
      type:String,
      default:''
    },
    messageList:{
      type:Array,
      default:[]
    },
    perPage:{
      type:Number,
      default:1
    },
    detailRouter:{
      type:String,
      default:''
    },
  },

  data () {
    return {
      
      showList:[],
      totalNum:0,
      pageCount:1,
      
    }
  },
  watch:{
    messageList(val){
        this.messageList = val;
        this.loadData();
    },
  },
  methods:{
    
    toOpenFile(url){
      window.open(url,'_blank')
    },
    toDetailPage(messageId){
      let url = this.$router.resolve({
         name: this.detailRouter,
         query: {detailId:messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
       
    },

    pageClick(num){
      this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.messageList)
    },
    loadData(){
      
      this.totalNum = this.messageList.length;
      this.pageCount = this.$PageUtil.getPageCount(this.totalNum,this.perPage);
      //获得第一页数据
      this.showList = this.$PageUtil.getStaticPage(1,this.perPage,this.messageList);
    },
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 

    
</style>
